var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.7619,
    height: 29.7606,
    rx: 14.8803,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.7619,
    height: 29.7606,
    rx: 14.8803,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1268 16.8758C22.1268 17.9773 21.874 18.9885 21.3683 19.9095C20.8627 20.8124 20.0862 21.5437 19.0389 22.1035C17.9915 22.6633 16.6913 22.9432 15.1384 22.9432H12.2672V29.7691H7.63531V10.7542H15.1384C16.6552 10.7542 17.9373 11.016 18.9847 11.5397C20.0321 12.0633 20.8176 12.7857 21.3413 13.7066C21.8649 14.6276 22.1268 15.684 22.1268 16.8758ZM14.7862 19.2594C15.6711 19.2594 16.3302 19.0518 16.7636 18.6364C17.197 18.2211 17.4137 17.6342 17.4137 16.8758C17.4137 16.1173 17.197 15.5305 16.7636 15.1151C16.3302 14.6998 15.6711 14.4921 14.7862 14.4921H12.2672V19.2594H14.7862Z",
    fill: "#272931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2221 5.93677H7.63525V8.99693H22.2221V5.93677Z",
    fill: "#E50913"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhite);
export default __webpack_public_path__ + "static/media/icon_white.a235f16fb0a14877c64e3f900ffe583e.svg";
export { ForwardRef as ReactComponent };